/** base64 ↔ ArrayBuffer 변환. 브라우저(WebCrypto)와 서버 API 라우트 양쪽에서 공유하므로
 * Node 전용 API(Buffer 등)는 절대 쓰지 않는다 — 클라이언트 번들에 섞이면 런타임 에러가 난다. */

export function bufferToBase64(buf: ArrayBuffer): string {
  const bytes = new Uint8Array(buf);
  let binary = "";
  for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
  return btoa(binary);
}

export function base64ToBuffer(base64: string): ArrayBuffer {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes.buffer;
}
